import * as React from "react";
import { CopyPlus, Quote } from "lucide-react";
import { ChronologyListActionsExport } from "./chronologyListActionsExport";
import { Button } from "@/components/ui/button";
import type { DocumentChronology } from "@/types/chronology";

interface ChronologyListActionsProps {
  handleAddRow: () => void;
  handleNarrative: () => void;
  documentChronology: DocumentChronology;
}

export const ChronologyListActions: React.FC<ChronologyListActionsProps> = ({
  documentChronology,
  handleNarrative,
  handleAddRow,
}) => (
  <div className="mt-3 text-right">
    <Button variant="secondary" size="sm" className="mr-2 w-full text-xs sm:w-auto" onClick={handleAddRow}>
      <CopyPlus className="mr-1 h-4 w-4" />
      Add row
    </Button>
    <Button variant="secondary" size="sm" className="mr-2 w-full text-xs sm:w-auto" onClick={handleNarrative}>
      <Quote className="mr-1 h-4 w-4" />
      Narrative
    </Button>

    <ChronologyListActionsExport documentChronology={documentChronology} />
  </div>
);
